import apiFaq from '@/api/faq'

const state = {
    error: null,
    isSubmitting: false
}

export const mutationTypes = {
    createFaqStart: '[create faq] Create faq start',
    createFaqSuccess: '[create faq] Create faq success',
    createFaqFailure: '[create faq] Create faq failure'
}

export const actionTypes = {
    createFaq: '[create faq] Create faq'
}

const mutations = {
    [mutationTypes.createFaqStart](state) {
        state.isSubmitting = true
    },

    [mutationTypes.createFaqSuccess](state) {
        state.isSubmitting = false
    },

    [mutationTypes.createFaqFailure](state, payload) {
        state.error = payload
        state.isSubmitting = false
    }
}

const actions = {
    [actionTypes.createFaq](context, {faq}) {
        context.commit(mutationTypes.createFaqStart)
        return new Promise(resolve => {
            apiFaq
                .createFaq(faq)
                .then(res => {
                    context.commit(mutationTypes.createFaqSuccess)
                    resolve(res.data)
                })
                .catch(resolve => {
                    context.commit(
                        mutationTypes.createFaqFailure,
                        resolve.response.data.errors
                    )
                })
        })
    }
}

export default {
    state,
    mutations,
    actions
}
